import { Component } from "@angular/core";
import { AgRendererComponent } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  standalone: false,
  template: `
    <a
      class="request-view-link"
      [attr.aria-label]="'View PF request ' + requestId + ' details in a new tab'"
      title="View request details in a new tab"
      [routerLink]="['/pf/requests', requestId]"
      target="_blank"
      rel="noopener noreferrer"
      (click)="onClick($event)"
    >
      {{ requestId }}
    </a>
  `,
  styles: [
    `
      :host {
        display: flex;
        height: 100%;
        align-items: center;
      }

      .request-view-link {
        display: inline-flex;
        align-items: center;
        height: 100%;
      }

      .request-view-link:hover {
        text-decoration: underline;
      }
    `,
  ],
})
export class PfRequestViewCellComponent implements AgRendererComponent {
  requestId: number;

  agInit(params: ICellRendererParams) {
    this.requestId = params.data.id;
  }

  refresh(params: ICellRendererParams): boolean {
    this.requestId = params.data.id;
    return true;
  }

  onClick(event: MouseEvent) {
    event.stopPropagation();
  }
}
